import React from 'react';
import { Svg, ISvg } from '../Svg';

export const Youtube: React.FC<ISvg> = (props) => (
  <Svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M21.7212 7.45489C21.6162 6.52771 20.7909 5.63863 19.9274 5.51952C14.6629 4.82683 9.33775 4.82683 4.07332 5.51952C3.20909 5.63837 2.38378 6.52771 2.2788 7.45489C1.90707 10.853 1.90707 14.1478 2.2788 17.5451C2.38378 18.4723 3.20909 19.3622 4.07332 19.4805C9.33775 20.1732 14.6629 20.1732 19.9274 19.4805C20.7909 19.3624 21.6162 18.4723 21.7212 17.5451C22.0929 14.1481 22.0929 10.853 21.7212 7.45489ZM11.1215 15.4734C10.7903 15.7071 10.3332 15.4703 10.3332 15.0649V9.93626C10.3332 9.53086 10.7903 9.29399 11.1215 9.52777L14.7546 12.0922C15.0368 12.2914 15.0368 12.71 14.7545 12.9092L11.1215 15.4734Z"
      fill="#FF0000"
    />
  </Svg>
);
